export const selectPathname = state => state.router.location.pathname;
